'use strict';exports.__esModule = true;exports.hideContactUsModal = exports.openContactUsModal = exports.sendContactUsForm = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var sendContactUsForm = (0, _reduxAct.createAction)('/SEND_CONTACT_US_FORM');
var sendContactUsFormSucess = (0, _reduxAct.createAction)('/SEND_CONTACT_US_FORM_SUCCESS');
var sendContactUsFormFail = (0, _reduxAct.createAction)('/SEND_CONTACT_US_FORM_FAIL');
var openContactUsModal = (0, _reduxAct.createAction)('/OPEN_CONTACT_US_FORM_MODAL');
var hideContactUsModal = (0, _reduxAct.createAction)('/HIDE_CONTACT_US_FORM_MODAL');

var initialState = {
  loading: false,
  loaded: false,
  error: null,
  isContactUsModalOpen: false };


var fetchPost = function fetchPost(_ref) {var data = _ref.data,isRealtor = _ref.isRealtor;return (
    _axios2.default.post('/mailing/' + (isRealtor ? 'contact_us_realtor' : 'contact'), data).
    then(sendContactUsFormSucess, sendContactUsFormFail));};

var postHandler = function postHandler(state, data) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    loaded: false,
    error: null }),
  promise(fetchPost, data));};

var postHandlerSuccess = function postHandlerSuccess(state, response) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: response.data });};


var postHandlerFail = function postHandlerFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Contact us failed');
  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: undefined,
    error: error });

};

var openContactUsModalHandler = function openContactUsModalHandler(state) {return Object.assign({},
  state, {
    isContactUsModalOpen: true });};


var hideContactUsModalHandler = function hideContactUsModalHandler(state) {return Object.assign({},
  state, {
    isContactUsModalOpen: false });};


var contactUs = (0, _reduxAct.createReducer)(function (on) {
  on(sendContactUsForm, postHandler);
  on(sendContactUsFormSucess, postHandlerSuccess);
  on(sendContactUsFormFail, postHandlerFail);
  on(openContactUsModal, openContactUsModalHandler);
  on(hideContactUsModal, hideContactUsModalHandler);
}, initialState);exports.


sendContactUsForm = sendContactUsForm;exports.
openContactUsModal = openContactUsModal;exports.
hideContactUsModal = hideContactUsModal;exports.default =


contactUs;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/contactUs.js
// module id = 169
// module chunks = 0